<template>
  <b-row>
    <b-col md="6">
      <b-card title="Obchod" class="fs-sm mb-4">
        <b-form-row class="mb-2">
          <b-col sm="4" tag="label"> Súčasný dodávateľ </b-col>
          <b-col sm="8">
            <template v-if="data.contract && data.contract._provider">
              {{ data.contract._provider.name }}
            </template>
            <template v-else> - </template>
          </b-col>
        </b-form-row>
        <b-form-row class="mb-2">
          <b-col sm="4" tag="label"> Výpoveď podáme za Vás </b-col>
          <b-col sm="8">
            <template v-if="data._cancellation">
              {{ data._cancellation.name }}
            </template>
            <template v-else> - </template>
          </b-col>
        </b-form-row>
        <b-form-row class="mb-2">
          <b-col sm="4" tag="label"> Stav výpovede </b-col>
          <b-col sm="8">
            <template v-if="data._cancellationState">
              {{ data._cancellationState.name }}
            </template>
            <template v-else> - </template>
          </b-col>
        </b-form-row>
        <b-form-row class="mb-2">
          <b-col sm="4" tag="label"> Zmluva uzatvorená </b-col>
          <b-col sm="8">
            <template v-if="data._agreementTerm">
              {{ data._agreementTerm.name }}
            </template>
            <template v-else> - </template>
          </b-col>
        </b-form-row>
        <b-form-row class="mb-2">
          <b-col sm="4" tag="label"> Zmluva končí dňa </b-col>
          <b-col sm="8">
            <template v-if="data.agreementEndDate">
              {{ data.agreementEndDate | formatDate }}
            </template>
            <template v-else> - </template>
          </b-col>
        </b-form-row>
        <b-form-row class="mb-2">
          <b-col sm="4" tag="label"> Variabilná zložka (€/kWh) </b-col>
          <b-col sm="8">
            <template v-if="data.contract && data.contract.variable">
              {{ data.contract.variable | formatNumber(4) }}
            </template>
            <template v-else> - </template>
          </b-col>
        </b-form-row>
        <b-form-row class="mb-2">
          <b-col sm="4" tag="label"> Fixná zložka (€/kW) </b-col>
          <b-col sm="8">
            <template v-if="data.contract && data.contract.fixed">
              {{ data.contract.fixed | formatNumber(4) }}
            </template>
            <template v-else> - </template>
          </b-col>
        </b-form-row>
        <b-form-row class="mb-2">
          <b-col sm="4" tag="label"> Dátum zmeny </b-col>
          <b-col sm="8">
            <template v-if="data.contract && data.contract.changeDate">
              {{ data.contract.changeDate | formatDate }}
            </template>
            <template v-else> - </template>
          </b-col>
        </b-form-row>
      </b-card>
      <b-card class="fs-sm mb-4" no-body>
        <b-card-body>
          <div class="d-flex justify-content-between align-items-start">
            <b-card-title> Distribúcia </b-card-title>
            <b-badge v-if="!data.active" variant="danger" class="fs-sm">
              NEAKTÍVNE
            </b-badge>
          </div>
          <b-form-row class="mb-2">
            <b-col sm="4" tag="label"> Dátum zač. odberu </b-col>
            <b-col sm="8">
              <template v-if="data.consumptionDateStart">
                {{ data.consumptionDateStart | formatDate }}
              </template>
              <template v-else> - </template>
            </b-col>
          </b-form-row>
          <b-form-row class="mb-2">
            <b-col sm="4" tag="label"> Spôsob evidencie </b-col>
            <b-col sm="8">
              <template v-if="data._evidenceType">
                {{ data._evidenceType.name }}
              </template>
              <template v-else> - </template>
            </b-col>
          </b-form-row>
          <b-form-row class="mb-2">
            <b-col sm="4" tag="label"> Číslo OP </b-col>
            <b-col sm="8">
              <template v-if="data.identityNumber">
                {{ data.identityNumber }}
              </template>
              <template v-else> - </template>
            </b-col>
          </b-form-row>
          <b-form-row class="mb-2">
            <b-col sm="4" tag="label"> Číslo zmluvy </b-col>
            <b-col sm="8">
              <template v-if="data.contractNumber">
                {{ data.contractNumber }}
              </template>
              <template v-else> - </template>
            </b-col>
          </b-form-row>
          <b-form-row class="mb-2">
            <b-col sm="4" tag="label"> Dátum konca odberu </b-col>
            <b-col sm="8">
              <template v-if="data.consumptionDateEnd">
                {{ data.consumptionDateEnd | formatDate }}
              </template>
              <template v-else> - </template>
            </b-col>
          </b-form-row>
          <b-form-row class="mb-2">
            <b-col sm="4" tag="label"> Spôsob ukončenia </b-col>
            <b-col sm="8">
              <template v-if="data._endpointType">
                {{ data._endpointType.name }}
              </template>
              <template v-else> - </template>
            </b-col>
          </b-form-row>
        </b-card-body>
      </b-card>
    </b-col>
    <b-col md="6">
      <b-card title="Adresa" class="fs-sm mb-4">
        <b-form-row class="mb-2">
          <b-col sm="4" tag="label"> Ulica </b-col>
          <b-col sm="8">
            <template v-if="data.street">
              {{ data.street }}
            </template>
            <template v-else> - </template>
          </b-col>
        </b-form-row>
        <b-form-row class="mb-2">
          <b-col sm="4" tag="label"> Číslo </b-col>
          <b-col sm="8">
            <template v-if="data.streetNumber">
              {{ data.streetNumber }}
            </template>
            <template v-else> - </template>
          </b-col>
        </b-form-row>
        <b-form-row class="mb-2">
          <b-col sm="4" tag="label"> Súp. číslo </b-col>
          <b-col sm="8">
            <template v-if="data.streetRegNumber">
              {{ data.streetRegNumber }}
            </template>
            <template v-else> - </template>
          </b-col>
        </b-form-row>
        <b-form-row class="mb-2">
          <b-col sm="4" tag="label"> Mesto </b-col>
          <b-col sm="8">
            <template v-if="data.city">
              {{ data.city }}
            </template>
            <template v-else> - </template>
          </b-col>
        </b-form-row>
        <b-form-row class="mb-2">
          <b-col sm="4" tag="label"> PSČ </b-col>
          <b-col sm="8">
            <template v-if="data.postCode">
              {{ data.postCode }}
            </template>
            <template v-else> - </template>
          </b-col>
        </b-form-row>
        <b-form-row class="mb-2">
          <b-col sm="4" tag="label"> Lokalita objektu </b-col>
          <b-col sm="8">
            <template v-if="data.locality">
              {{ data.locality }}
            </template>
            <template v-else> - </template>
          </b-col>
        </b-form-row>
        <b-form-row class="mb-2">
          <b-col sm="4" tag="label"> Názov objektu </b-col>
          <b-col sm="8">
            <template v-if="data.localityName">
              {{ data.localityName }}
            </template>
            <template v-else> - </template>
          </b-col>
        </b-form-row>
        <b-form-row class="mb-2">
          <b-col sm="4" tag="label"> Súradnice </b-col>
          <b-col sm="8">
            <template v-if="data.coordinates">
              {{ data.coordinates }}
            </template>
            <template v-else> - </template>
          </b-col>
        </b-form-row>
      </b-card>
      <b-card title="Technické údaje" class="fs-sm mb-4">
        <b-form-row class="mb-2">
          <b-col sm="4" tag="label"> OM </b-col>
          <b-col sm="8">
            <template v-if="data.heatNumber">
              {{ data.heatNumber }}
            </template>
            <template v-else> - </template>
          </b-col>
        </b-form-row>
        <b-form-row class="mb-2">
          <b-col sm="4" tag="label"> Typ merania </b-col>
          <b-col sm="8">
            <template v-if="data._measureType">
              {{ data._measureType.name }}
            </template>
            <template v-else> - </template>
          </b-col>
        </b-form-row>
        <b-form-row class="mb-2">
          <b-col sm="4" tag="label"> % pomer dodaného tepla - byty </b-col>
          <b-col sm="8">
            <template v-if="data.heatRatioRes">
              {{ data.heatRatioRes | formatNumber(2) }}
            </template>
            <template v-else> - </template>
          </b-col>
        </b-form-row>
        <b-form-row class="mb-2">
          <b-col sm="4" tag="label"> % pomer dodaného tepla - nebyty </b-col>
          <b-col sm="8">
            <template v-if="data.heatRatioNonRes">
              {{ data.heatRatioNonRes | formatNumber(2) }}
            </template>
            <template v-else> - </template>
          </b-col>
        </b-form-row>
        <b-form-row class="mb-2">
          <b-col sm="4" tag="label"> Celková plocha - byty (m2) </b-col>
          <b-col sm="8">
            <template v-if="data.totalAreaRes">
              {{ data.totalAreaRes | formatNumber(2) }}
            </template>
            <template v-else> - </template>
          </b-col>
        </b-form-row>
        <b-form-row class="mb-2">
          <b-col sm="4" tag="label"> Celkový objem - byty (m3) </b-col>
          <b-col sm="8">
            <template v-if="data.totalVolRes">
              {{ data.totalVolRes | formatNumber(2) }}
            </template>
            <template v-else> - </template>
          </b-col>
        </b-form-row>
        <b-form-row class="mb-2">
          <b-col sm="4" tag="label"> Celková plocha - nebyty (m2) </b-col>
          <b-col sm="8">
            <template v-if="data.totalAreaNonRes">
              {{ data.totalAreaNonRes | formatNumber(2) }}
            </template>
            <template v-else> - </template>
          </b-col>
        </b-form-row>
        <b-form-row class="mb-2">
          <b-col sm="4" tag="label"> Celkový objem - nebyty (m3) </b-col>
          <b-col sm="8">
            <template v-if="data.totalVolNonRes">
              {{ data.totalVolNonRes | formatNumber(2) }}
            </template>
            <template v-else> - </template>
          </b-col>
        </b-form-row>
        <b-form-row class="mb-2">
          <b-col sm="4" tag="label"> Počet podlaží </b-col>
          <b-col sm="8">
            <template v-if="data.numFloors">
              {{ data.numFloors }}
            </template>
            <template v-else> - </template>
          </b-col>
        </b-form-row>
        <b-form-row class="mb-2">
          <b-col sm="4" tag="label"> Svetlá výška byt/nebyt (m) </b-col>
          <b-col sm="8">
            <template v-if="data.height">
              {{ data.height | formatNumber(2) }}
            </template>
            <template v-else> - </template>
          </b-col>
        </b-form-row>
      </b-card>
    </b-col>
  </b-row>
</template>
<script>
export default {
  props: {
    data: {
      type: Object,
      required: true,
    },
  },
}
</script>
